<template>
  <li class="c-menu__item" v-if="item.hasMenu && canShow(type, item.path)" v-bind:class="{ 'has-sub': hasNext(), 'line-through': item.inactive && !parentRoute }">
    <router-link v-if="item.hasLink && item.hasMenu && !item.hasOwnProperty('fullRoute')" :to="getRoute()" class="c-menu__link">
      <div class="c-menu__icon" v-if="item.iconMenu">
        <i :class="item.iconMenu"></i>
      </div>
      <div class="c-menu__text">{{ label }}</div>
    </router-link>

    <a v-else-if="item.hasLink && item.hasMenu && item.hasOwnProperty('fullRoute')" :href="item.fullRoute" class="c-menu__link">
      <div class="c-menu__icon" v-if="item.iconMenu">
        <i :class="item.iconMenu"></i>
      </div>
      <div class="c-menu__text">{{ label }}</div>
    </a>

    <a v-else href="#" class="c-menu__link">
      <div class="c-menu__icon" v-if="item.iconMenu">
        <i :class="item.iconMenu"></i>
      </div>
      <div class="c-menu__text">{{ label }}</div>
    </a>

    <ul v-for="action in item.children" v-if="hasNext()" :key="action.label" class="c-menu">
      <menu-sidebar-item :type="type" :item="action" :parentRoute="getRoute()" :level="2"/>
    </ul>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { cloneDeep } from 'lodash'

  export default {
    name: 'menu-sidebar-item',
    props: {
      parentRoute: {
        type: String,
        required: false
      },
      type: {
        type: String,
        required: true
      },
      item: {
        type: Object
      },
      level: {
        type: Number,
        required: true
      }
    },
    methods: {
      hasNext () {
        for (let i in this.item.children) {
          if (this.item.children[i].hasMenu) {
            if (this.item.children[i].children.length) {
              for (let j in this.item.children[i].children) {
                if (this.item.children[i].children[j].hasMenu) {
                  this.item.children[i].children[j].path = this.item.children[i].path + '/' + this.item.children[i].children[j].path
                  this.item.children.push(cloneDeep(this.item.children[i].children[j]))
                  this.item.children[i].children[j].hasMenu = false
                }
              }
            }
            return true
          }
        }
        return false
      },
      getRoute () {
        let route = `/`

        if (this.parentRoute) {
          if (route.indexOf(this.type) === -1 && this.parentRoute.indexOf(this.type) === -1) {
            route += `${this.type}/`
          }

          route += `${this.parentRoute}/`
        }

        return (route + this.item.path).replace(/\/\//g, '/')
      },
      canShow (type, identifier) {
        return type === 'general' || this.modules.find(module => module.type === type && module.identifier === identifier) || this.level > 1
      }
    },
    computed: {
      ...mapGetters('module', [
        'modules'
      ]),
      label () {
        if (this.item.path === '/') {
          return this.$t('dashboard.label')
        }

        if (this.item.hasOwnProperty('fullRoute')) {
          return this.item.label
        }

        if (this.parentRoute) {
          if (this.$te(`${this.parentRoute.replace('/', '')}.${this.item.path}.label`)) {
            return this.$t(`${this.parentRoute.replace('/', '')}.${this.item.path}.label`)
          }
        }

        let path = this.item.path
        if (this.item.path.indexOf('/') !== -1) {
          path = this.item.path.split('/')[1]
        }

        return this.$t(`${path}.label`)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .line-through
    & > a
      text-decoration: line-through
</style>



// WEBPACK FOOTER //
// MenuSidebarItem.vue?56a73f31